


















































































































































import { Component, Emit, Prop, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { DataTable, Col } from '@/components/molecules/DataTable'
import { CollectionFlag } from '@/types'
import { IconBibliography } from '@/components/molecules/IconBibliography'
import { CollectionListDetailBibliography } from '@/api'
import { CollectionListEditInfoItem } from '@/components/templates/collection-list/CollectionListEditInfo.vue'
import { InputCollectionNo } from '@/components/molecules/InputCollectionNo'

export interface CollectionListEditTableItem
  extends CollectionListDetailBibliography {}

const COLS: Col[] = [
  {
    width: 50,
    items: [
      {
        name: 'no',
        headerText: '順位',
        align: 'right'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'bibliographyRealId',
        headerText: '書誌番号'
      }
    ]
  },
  {
    width: '18',
    resizable: true,
    items: [
      {
        name: 'displayTitle',
        headerText: 'タイトル'
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'displayAuthor',
        headerText: '責任表示'
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'displayPublisher',
        headerText: '出版者'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'displayClass',
        headerText: '分類番号'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'displaySize',
        headerText: '大きさ'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'displayMaterialFormat',
        headerText: '資料形態'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'displayPublished',
        headerText: '出版年'
      }
    ]
  },
  {
    width: '16',
    resizable: true,
    items: [
      {
        name: 'isbn',
        headerText: 'ISBN'
      }
    ]
  },
  {
    width: 140,
    items: [
      {
        name: 'rank',
        align: 'center'
      }
    ]
  },
  {
    width: 30,
    items: [
      {
        name: 'remove',
        align: 'center'
      }
    ]
  }
]

@Component({
  components: { InputCollectionNo, IconBibliography, DataTable }
})
export default class CollectionListEditTable extends ComponentVue {
  @Ref()
  inputCollectionNo!: InputCollectionNo

  @PropSync('input', {
    type: Object,
    required: true
  })
  infoItem!: CollectionListEditInfoItem

  @Prop({
    type: Array,
    required: true
  })
  items!: CollectionListEditTableItem[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  get cols(): Col[] {
    return COLS
  }

  focusCollectionNo(): void {
    this.inputCollectionNo.focus()
  }

  bibliographyId(item: CollectionListEditTableItem) {
    if (item.bibliographyRealId === 0) {
      return ''
    }

    return item.prefix + item.bibliographyRealId.toString().padStart(10, '0')
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  movableUp(value: CollectionListEditTableItem): boolean {
    const index = this.items.findIndex(
      item => item.bibliographyRealId === value.bibliographyRealId
    )

    return index !== 0
  }

  movableDown(value: CollectionListEditTableItem): boolean {
    const index = this.items.findIndex(
      item => item.bibliographyRealId === value.bibliographyRealId
    )

    return index !== this.items.length - 1
  }

  onClickUp(index: number) {
    this.items.splice(index - 1, 2, this.items[index], this.items[index - 1])
  }

  onClickDown(index: number) {
    this.items.splice(index, 2, this.items[index + 1], this.items[index])
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onFileChange(e: Event) {
    const files = (e.target as HTMLInputElement).files
    if (files === null) return

    this.$emit('file-upload', files[0])
  }

  @Emit('search')
  onClickSearch(): void {}

  @Emit('input:collection-no')
  onInputCollectionNo(collectionNo: string): string {
    this.resetErrorMessage(this.infoItem.collectionNo)

    return collectionNo
  }

  @Emit('determine:collection-no')
  onDetermineCollectionNo(): void {}

  @Emit('file-read')
  onFileRead() {}

  @Emit('file-clear')
  onFileClear() {}

  @Emit('download')
  onClickDownload(): void {}

  @Emit('remove')
  onClickRemove(index: number): number {
    return index
  }

  @Emit('link:title')
  onClickTitle(bibliographyRealId: number): number {
    return bibliographyRealId
  }
}
